import type { PayeeId, Payee, Transaction } from "@budgeter/shared";

/** Payees by their most recent transaction, newest first (transfers excluded). */
export function recentPayees(
  transactions: Iterable<Transaction>,
  payees: Iterable<Payee>,
  limit = 10,
): PayeeId[] {
  const live = new Set<string>();
  for (const p of payees) {
    if (!p.deleted) {
      live.add(p.id);
    }
  }
  const last = new Map<PayeeId, string>();
  for (const t of transactions) {
    if (t.deleted || !t.payeeId || t.transfer || !live.has(t.payeeId)) {
      continue;
    }
    const prev = last.get(t.payeeId);
    if (!prev || t.date > prev) {
      last.set(t.payeeId, t.date);
    }
  }
  return [...last.entries()]
    .sort((a, b) => (a[1] < b[1] ? 1 : a[1] > b[1] ? -1 : 0))
    .slice(0, limit)
    .map(([id]) => id);
}

/** `40 m`, `1.2 km`. */
export function formatDistance(meters: number): string {
  if (meters < 1000) {
    return `${Math.round(meters)} m`;
  }
  return `${(meters / 1000).toFixed(1)} km`;
}
